/**
 * Style-update queue for the theme namespace.
 *
 * The Liquid-driven half of the old inline bootstrap (money formats, translated strings, routes
 * and theme settings) now ships as an inert application/json block that the head reads with
 * JSON.parse. What is left here is the only part that was ever real code: a microtask queue that
 * batches style writes so callers do not each trigger their own layout pass.
 *
 * This file is deferred, so it runs after the head has populated `window.theme` and before
 * theme.js. Everything it defines is used from event handlers, never during parse.
 */
// `theme` is populated by the synchronous bootstrap in the layout's <head>. Guard anyway:
// if that bootstrap ever throws (missing #theme-config-data, malformed JSON), a bare
// `theme.x = ...` here would throw ReferenceError and take the whole file down with it.
window.theme = window.theme || {};

theme.enqueueStyleUpdateQueue = [];
theme.enqueueStyleUpdateTimeoutId = null;

theme.enqueueStyleUpdate = (cb) => {
  clearTimeout(theme.enqueueStyleUpdateTimeoutId);
  theme.enqueueStyleUpdateQueue.push(cb);
  theme.enqueueStyleUpdateTimeoutId = setTimeout(() => {
    while (theme.enqueueStyleUpdateQueue.length > 0) {
      theme.enqueueStyleUpdateQueue.pop()();
    }
  }, 0);
};
